import React from "react";
import Button from "@mui/material/Button";

//Button Props
interface ButtonProps {
  type?: "submit" | "reset" | "button";
  className?: string;
  children: React.ReactNode;
  onClick?: { (e: any): void } | null;
  disabled?: boolean;
  dataTestId?: string;
  id?: string;
  isLoading?: boolean;
  color?:
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning";
  startIcon?: any;
  variant: "contained" | "outlined" | "text";
  size: "small" | "medium" | "large";
  style?: any;
  component?: any;
  to?: any;
}

//Button Core Component
export const YSButton: React.FC<ButtonProps> = ({
  className,
  children,
  onClick,
  disabled,
  dataTestId,
  type,
  id,
  isLoading,
  color,
  startIcon,
  variant,
  size,
  style,
  component,
  to,
}) => {
  return (
    <>
      <Button
        className={className}
        data-testid={dataTestId}
        onClick={onClick}
        disabled={disabled}
        type={type}
        id={id}
        color={color}
        variant={variant}
        size={size}
        startIcon={startIcon}
        style={style}
        component={component}
        to={to}
      >
        {isLoading ? (
          <span
            className="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
        ) : (
          children
        )}
      </Button>
    </>
  );
};
